module.exports = __webpack_public_path__ + "img/reply-icon.373d6615.svg";